import React, { useState, createContext, useContext } from 'react';
import { CartItemType } from '../components/CartItem';
interface CartContextType {
  items: CartItemType[];
  addItem: (item: CartItemType) => void;
  removeItem: (id: string) => void;
  updateQuantity: (id: string, quantity: number) => void;
  clearCart: () => void;
  cartCount: number;
  subtotal: number;
}
const CartContext = createContext<CartContextType | undefined>(undefined);
export function CartProvider({
  children
}: {
  children: ReactNode;
}) {
  const [items, setItems] = useState<CartItemType[]>([]);
  const addItem = (newItem: CartItemType) => {
    setItems(prevItems => {
      // If it's a menu item, check if it already exists to increment quantity
      if (newItem.type === 'menu') {
        const existingItemIndex = prevItems.findIndex(item => item.id === newItem.id);
        if (existingItemIndex >= 0) {
          const updatedItems = [...prevItems];
          updatedItems[existingItemIndex] = {
            ...updatedItems[existingItemIndex],
            quantity: (updatedItems[existingItemIndex].quantity || 1) + (newItem.quantity || 1)
          };
          return updatedItems;
        }
      }
      return [...prevItems, newItem];
    });
  };
  const removeItem = (id: string) => {
    setItems(prevItems => prevItems.filter(item => item.id !== id));
  };
  const updateQuantity = (id: string, quantity: number) => {
    if (quantity <= 0) {
      removeItem(id);
      return;
    }
    setItems(prevItems => prevItems.map(item => item.id === id ? {
      ...item,
      quantity
    } : item));
  };
  const clearCart = () => {
    setItems([]);
  };
  const cartCount = items.reduce((count, item) => count + (item.quantity || 1), 0);
  const subtotal = items.reduce((total, item) => {
    return total + item.price * (item.quantity || 1);
  }, 0);
  return <CartContext.Provider value={{
    items,
    addItem,
    removeItem,
    updateQuantity,
    clearCart,
    cartCount,
    subtotal
  }} data-id="element-811">
      {children}
    </CartContext.Provider>;
}
export function useCart() {
  const context = useContext(CartContext);
  if (context === undefined) {
    throw new Error('useCart must be used within a CartProvider');
  }
  return context;
}